import axios from "axios";
import type { Application } from "@/types/jben/application.ts";

type Args = {
  application: Application;
  submitPath: string;
  fingerprint: string;
  jobApplicationRequestToken?: string;
  markAsDreamJob?: boolean;
};

export async function submitApplication({
  application,
  submitPath,
  fingerprint,
  jobApplicationRequestToken,
  markAsDreamJob,
}: Args) {
  const body: Record<string, unknown> = {
    job_application: application,
    fingerprint,
  };

  if (jobApplicationRequestToken) {
    body["request_token"] = jobApplicationRequestToken;
  }

  if (markAsDreamJob) {
    body["mark_as_dream_job"] = true;
  }

  return axios.post(submitPath, body);
}
